const menu = {

    items: [
        {
            name: "Dashboard",
            to: "dashboard",
            permission: "page.dashboard",
            metaGroup: "dashboard",
            icon: "/images/menu-icons/dashboard_24px.svg"
        },
        {
            name: "SSP",
            to: "ssp-list-new",
            permission: "page.ssp-new",
            metaGroup: "ssp",
            icon: "/images/menu-icons/ssp-icon.svg"
        },
        {
            name: "DSP",
            to: "dsp-list-new",
            permission: "page.dsp-new",
            metaGroup: "dsp",
            icon: "/images/menu-icons/dsp-icon.svg"
        },
        {
            name: "Lists",
            permission: "page.lists",
            icon: "/images/menu-icons/list_24px.svg",
            items: [
                {
                    name: "Adult Sites",
                    to: "dsp-lists-trade",
                    permission: "page.lists.adultsites",
                    params: {
                        name: "adultsite"
                    }
                },
                {
                    name: "Blocked Sites",
                    to: "trade-options-blocked-site",
                    permission: "page.lists.blockedsites",
                    params: {
                        side: "global",
                        name: "site",
                        type: "blocked",
                        id: 0
                    }
                },
                {
                    name: "Blocked Bundles",
                    to: "trade-options-blocked-bundle",
                    permission: "page.lists.blockedbundles",
                    params: {
                        side: "global",
                        name: "bundle",
                        type: "blocked",
                        id: 0
                    }
                },
                {
                    name: "DSP Tracking Domains",
                    to: "dsp-tracking-domains",
                    permission: "page.lists.dsp-tracking-domains",
                },
            ],
            metaGroup: "lists"
        },
        {
            name: "Statistics",
            permission: "page.statistics",
            icon: "/images/menu-icons/bar_chart_24px.svg",
            items: [
                {
                    name: "All Statistics",
                    to: "statistics-all-redesign",
                    permission: "page.statistics.all-redesign",
                },
                {
                    name: "Summary Statistics",
                    to: "statistics-summary",
                    permission: "page.statistics.summary",
                },
                {
                    name: "Publisher Statistics",
                    to: "statistics-publisher",
                    permission: "page.statistics.publisher",
                },
                {
                    name: "Scan Statistics",
                    to: "statistics-scans",
                    permission: "page.statistics.scans",
                },
                {
                    name: "VCR Statistics",
                    to: "statistics-vcr",
                    permission: "page.statistics.vcr",
                },
                {
                    name: "LTR Statistics",
                    to: "statistics-ltr",
                    permission: "page.statistics.ltr",
                },
                {
                    name: "Cookie Sync",
                    to: "statistics-cookiesync",
                    permission: "page.statistics.cookiesync",
                },
                {
                    name: "Indirect Demand Statistics",
                    to: "statistics-indirect-demand",
                    permission: "page.statistics.indirect-demand",
                },
                {
                    name: "Schain Statistics",
                    to: "statistics-schain",
                    permission: "page.statistics.schain",
                },
                {
                    name: "Duplicate IP/IFA Statistics",
                    to: "statistics-duplicate-ip-ifa",
                    permission: "page.statistics.duplicate-ip-ifa",
                },
            ]
        },
        {
            name: "Scanners",
            permission: "page.scanners",
            metaGroup: "scanners",
            icon: "/images/menu-icons/warning_24px.svg",
            items: [
                {
                    name: "Scan Limits",
                    to: "pixalate",
                    permission: "page.scanners.scanlimits",
                },
                {
                    name: "Blocked Crids in GeoEdge",
                    to: "blocked-crids-geoedge",
                    permission: "page.scanners.blocked-crids-geoedge",
                },
                {
                    name: "DSP Scans in GeoEdge",
                    to: "dsp-scans-geoedge",
                    permission: "page.scanners.dsp-scans-geoedge",
                },
            ]
        },
        {
            name: "SSP Info",
            permission: "page.sspinfo",
            icon: "/images/menu-icons/info_outline_24px.svg",
            items: [
                {
                    name: "By Traffic Types",
                    to: "ssp-info-traffic",
                    permission: "page.sspinfo.traffic",
                },
                {
                    name: "By Requests",
                    to: "ssp-info-requests",
                    permission: "page.sspinfo.requests",
                },
                {
                    name: "Hourly SSP Requests",
                    to: "ssp-info-hourly-requests",
                    permission: "page.sspinfo.hourly-requests",
                },
                {
                    name: "By Min Requirements",
                    to: "ssp-info-requirements",
                    permission: "page.sspinfo.requirements",
                }
            ]
        },
        {
            name: "DSP Info",
            permission: "page.dspinfo",
            icon: "/images/menu-icons/info_outline_24px.svg",
            items: [
                {
                    name: "DSP Info",
                    to: "dsp-info",
                    permission: "page.dspinfo.info",
                },
                {
                    name: "Nurl/Burl Call Errors",
                    to: "dsp-nurl-errors",
                    permission: "page.dspinfo.nurlerrors",
                },
            ]
        },
        {
            name: "Integration Side",
            permission: "page.integration",
            items: [
                {
                    name: "Report SSP",
                    to: "integration-report-ssp",
                    permission: "page.integration.reportssp"
                },
                {
                    name: "Report DSP",
                    to: "integration-report-dsp",
                    permission: "page.integration.reportdsp"
                },
            ]
        },
        {
            name: "Exchange",
            permission: "page.exchange",
            icon: "/images/menu-icons/mdi_exchange.svg",
            items: [
                {
                    name: "SSP/DSP Company",
                    to: "ssp-dsp-company",
                    permission: "page.exchange.sspdspcompany",
                },
                {
                    name: "Report SSP",
                    to: "report-ssp",
                    permission: "page.exchange.reportssp"
                },
                {
                    name: "Report DSP",
                    to: "report-dsp",
                    permission: "page.exchange.reportdsp"
                },
                {
                    name: "Report Manager",
                    to: "report-manager",
                    permission: "page.report-manager",
                },
                {
                    name: "Sellers & Supply Control",
                    to: "sellers",
                    permission: "page.exchange.sellers",
                },
                {
                    name: "Ads.txt Lines",
                    to: "ads-txt-lines",
                    permission: "page.exchange.ads-txt-lines",
                },
                {
                    name: "DSP Sellers.json file",
                    to: "dsp-sellers-json",
                    permission: "page.exchange.dspsellersjsonfile",
                },
                {
                    name: "Traffic without Filtering",
                    to: "traffic-without-filtering",
                    permission: "page.exchange.trafficwithoutfiltering",
                },
                {
                    name: "Vast Macros",
                    to: "exchange-macroses",
                    permission: "page.exchange.vastmacros",
                },
                {
                    name: "Prebid Sources",
                    to: "dsp-sources",
                    permission: "page.exchange.prebidsources",
                },
                {
                    name: "Request Booster",
                    to: "request-booster",
                    permission: "page.exchange.request-booster"
                },
            ],
            metaGroup: "exchange"
        },
        {
            name: "Logger",
            permission: "page.logger",
            icon: "/images/menu-icons/logger-icon.svg",
            items: [
                {
                    name: "Traffic Logger",
                    to: "logger",
                    permission: "page.logger.trafficlogger"
                },
                {
                    name: "Request Logger",
                    to: "request-logger",
                    permission: "page.logger.requestlogger"
                },
                {
                    name: "Activity Logger",
                    to: "activity-logger",
                    permission: "page.logger.activitylogger"
                },
                {
                    name: "Campaign Logger",
                    to: "campaign-logger",
                    permission: "page.logger.campaignlogger"
                },
                {
                    name: "Pattern Logger",
                    to: "pattern-logger",
                    permission: "page.logger.pattern-logger"
                }
            ],
            metaGroup: "logger"
        },
        {
            name: "Crawler",
            permission: "page.crawler",
            icon: "/images/menu-icons/crawler-icon.svg",
            items: [
                {
                    name: "Crawler",
                    to: "crawler",
                    permission: "page.crawler.crawler"
                },
                {
                    name: "Metrics",
                    to: "crawler-metrics",
                    permission: "page.crawler.metrics"
                },
                {
                    name: "Analytics",
                    to: "crawler-analytics",
                    permission: "page.crawler.analytics"
                }
            ],
            metaGroup: "crawler"
        },
        {
            name: "PMP Deals",
            permission: "page.pmpdeals",
            icon: "/images/menu-icons/mdi_exchange.svg",
            items: [
                {
                    name: "SSP Deals",
                    to: "pmp-deals-ssp",
                    permission: "page.pmpdeals.ssp",
                },
                {
                    name: "DSP Deals",
                    to: "pmp-deals-dsp",
                    permission: "page.pmpdeals.dsp",
                },
                {
                    name: "SWYM DSP Deals",
                    to: "pmp-deals-swym",
                    permission: "page.pmpdeals.swym",
                },
            ],
            metaGroup: "pmpdeals"
        },
    ],
    adminItems: [
        {
            name: "Admin",
            permission: "page.admin",
            icon: "/images/menu-icons/admin-icon.svg",
            items: [
                {
                    name: "Manage Users",
                    to: "admin-users-manage",
                    permission: "page.admin.manageusers"
                },
                {
                    name: "History Changes",
                    to: "admin-history",
                    permission: "page.admin.historychanges"
                },
                {
                    name: "View Logs",
                    href: "/admin/logs",
                    permission: "page.admin.viewlogs",
                    blank: true
                }
            ],
            metaGroup: "admin"
        },
        {
            name: "Finance",
            permission: "page.finance",
            icon: "/images/menu-icons/finance-icon.svg",
            items: [
                {
                    name: "DSP Prepayment Balance",
                    to: "finance-dsplimits",
                    permission: "page.finance.dsplimits",
                },
                {
                    name: "Time zones",
                    to: "finance-timezone",
                    permission: "page.finance.timezones",
                },
                {
                    name: "Billing Report",
                    to: "finance-billingreport",
                    permission: "page.finance.billingreport",
                },
                {
                    name: "Billing Report (Summary)",
                    href: "/finance/billingreport/summary",
                    permission: "page.finance.billingreportsummary",
                },
                {
                    name: "Daily Report",
                    to: "finance-dailyreport",
                    permission: "page.finance.dailyreport",
                },
                {
                    name: "Partner API Links",
                    to: "finance-partner-api-links",
                    permission: "page.finance.partnerapilinks",
                },
                {
                    name: "Financial Report",
                    to: "finance-financialreport",
                    permission: "page.finance.financialreport",
                },
                {
                    name: "All Companies",
                    to: "finance-all-companies",
                    permission: "page.finance.allcompanies",
                }
            ],
            metaGroup: "finance"
        },
        {
            name: "Developer",
            permission: "page.developer",
            icon: "/images/menu-icons/info_outline_24px.svg",
            items: [
                {
                    name: "Servers",
                    to: "developer-server-manager",
                    permission: "page.developer.servers",
                    params: {
                        side: "core",
                        type: "node"
                    }
                },
                {
                    name: "Servers (DSP)",
                    to: "developer-server-manager-dsp",
                    permission: "page.developer.serversdsp",
                    params: {
                        side: "dsp",
                        type: "node"
                    }
                },
                {
                    name: "Cappings (DSP)",
                    to: "developer-server-manager-cappings-dsp",
                    permission: "page.developer.cappings-dsp",
                    params: {
                        side: "dsp",
                        type: "capping"
                    }
                },
                {
                    name: "Live Statistic",
                    to: "developer-live-statistic",
                    permission: "page.developer.livestatistic",
                },
                {
                    name: "Live Statistic (DSP)",
                    to: "developer-live-statistic-dsp",
                    permission: "page.developer.livestatistic-dsp",
                },
                {
                    name: "Permissions",
                    to: "developer-permissions",
                    permission: "page.developer.permissions",
                },
                {
                    name: "Project Settings",
                    to: "developer-project-settings",
                    permission: "page.developer.project_settings",
                },
                {
                    name: "Artisan",
                    to: "developer-artisan",
                    permission: "page.developer.artisan",
                },
                {
                    name: "Horizon Dashboard",
                    href: "/horizon/dashboard",
                    permission: "page.developer.horizon_dashboard",
                },
                {
                    name: "Test coverage",
                    href: "/coverage-html/index.html",
                    permission: "page.developer.test_coverage",
                }
            ],
            metaGroup: "developer"
        }
    ]
};

export default menu;
